import decorImg from './decor.svg';
import './Decor.css';

/** From Figma Group 1321317607 (141:17388) — sparkles & soft glows around the pack. */
export function Decor() {
  return (
    <img
      className="sticker-reward-decor"
      src={decorImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
